export default "__VITE_ASSET__Cf8CJbRG__"